import { get } from 'lodash/get'
import { handleError } from 'helper/rest'
import { clientPublic } from 'helper/axios'
import { string } from 'prop-types'

export const getResultMember = async ({ page, limit, params, token, isSkill }) => {
  try {
    return await clientPublic
      // .post(`account/search?`, params, {
      .post(`account/search?page=${page}&limit=${limit}&skill=${isSkill}`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const getResultCompany = async ({ token }) => {
  try {
    return await clientPublic
      .get(`company?level=1&level_id=0&orderby=`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

// modal skill api
export const getSKillUser = async ({ /*company_id,*/ token }) => {
  try {
    return await clientPublic
      .get(`professionalskill`, {
        // .get(`professionalskill?company_id=${company_id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}
///Profile USer
export const getProfileUser = async ({ iduser, token }) => {
  // console.log(iduser)
  try {
    return await clientPublic
      .get(`account/${iduser}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

// Callback api Update
export const getCallbackskillUser = async ({ params, token }) => {
  try {
    return await clientPublic
      // .post(`account/search?`, params, {
      .post(`account/skill/${params.account_id}`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

// add professionalskill
export const addProfessionalSkill = async ({ params, token }) => {
  try {
    return await clientPublic
      // .post(`account/search?`, params, {
      .post(`professionalskill`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}
//get skill by project and company
export const getProfessionalSkillByProject = async ({
  project_id,
  company_id,
  token,
}) => {
  // console.log(company_id)
  try {
    return await clientPublic
      .get(`professionalskill?company_id=${company_id}&project_id=${project_id}`, {
        // .get(`professionalskill?company_id=43`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}
